var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('show-code',{attrs:{"code":_vm.fieldInfoList}}),_c('load-block',{attrs:{"load":!_vm.load}}),_c('ImportCommon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }